export const OPEN_FILTERS = {
  is_open: { value: true },
  ordering: { value: 1 }
};
export const CLOSE_FILTERS = {
  is_closed: { value: true },
  ordering: { value: 3 }
};
export const MY_SUBMISSIONS_FILTERS = {
  have_responded: { value: true },
  ordering: { value: 1 }
};

export const TENDERS_TABS = {
  open: {
    text: 'Below is a list of all our live projects.',
    filters: OPEN_FILTERS
  },
  closed: {
    text: 'The below projects are closed.',
    filters: CLOSE_FILTERS
  },
  'my-submissions': {
    text: 'Below you can see a list of projects that you have submitted.',
    filters: MY_SUBMISSIONS_FILTERS
  }
};
